import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-reveal-clip]')

    elements.forEach((el) => {
        ScrollTrigger.create({
            trigger: el,
            start: el.dataset.start || 'top 80%',
            // markers: true,
            toggleClass: {
                targets: el,
                className: 'is-revealed'
            },
            once: true // 👈 alleen 1 keer afspelen
            // markers: true,
        })
    })

    setTimeout(() => {
        ScrollTrigger.refresh()
    }, 1000)
})
